export function exportEndpointsEnum<T extends { [key in string]: string }>(
  entityName: string,
  endpoints: T,
  version: string = "v1",
  backendUrl = process.env.REACT_APP_BACKEND_URL
) {
  return Object.fromEntries(
    Object.entries(endpoints).map(([name, pathname]) => [
      name,
      `${backendUrl}/${version}/${entityName}${pathname}`,
    ])
  ) as { [key in keyof T]: string };
}

export function blobToBase64(blob: Blob) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}
